module.exports = __webpack_public_path__ + "static/media/PDF_59.8c9f852e.pdf";